/* ABCD cart drawer: reward card (rebuilt 24 Oct 2026).
   One light card at the top of the cart drawer with three steps, counted in items (not euros):
     1 item    5% with the welcome code ABCD5 (pop-up sign-up, applied to the cart automatically)
     2 items   free socks, colour and size chosen by the shopper
     3+ items  10% off everything: the automatic discount "Koop 3+, bespaar 10%"
   The euro steps (socks from 150, laces from 250) and the free shoe are gone. Shipping is free on
   every order, so the card says nothing about shipping.
   The socks are stored as a line item property ("Cadeau sokken": "Zwart · 38-42") on the first line,
   NOT as an extra product: a free product line would count as an item for the 10 percent discount.
   The property shows in checkout, the confirmation mail and the order, so the gift is packed.
   Old "Cadeau veters" properties are removed. If this script fails, the old bar stays visible
   (the old block is only hidden once the card is mounted). */
(function () {
  'use strict';

  var root = document.getElementById('CartDrawerPro');
  if (!root || root.dataset.abcdLadder) return;
  var anchor = root.querySelector('[data-cdp-ms]');
  if (!anchor || !anchor.parentNode) return;
  root.dataset.abcdLadder = '1';

  var lang = String(document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
  var LOCALE = { nl: 'nl-BE', fr: 'fr-BE', de: 'de-DE', it: 'it-IT', en: 'en-IE' }[lang] || 'nl-BE';
  function cfg() { return window.OlyxFixesConfig || {}; }
  function pct3() { return Number(cfg().tier3) || 10; }

  /* ---------- texts ---------- */
  var T = {
    nl: {
      label: 'Jouw voordeel',
      t1: '1 artikel', s1: '5% met code', t2: '2 artikelen', s2: 'Gratis sokken', t3: '3+ artikelen', s3: '[p]% korting',
      A: 'Voeg nog 1 artikel toe en krijg <em>gratis sokken</em> naar keuze.',
      Asub: 'Jij kiest de kleur en de maat. Vanaf 3 artikelen krijg je <b>[p]% korting op alles</b>.',
      B: '<em>Gratis sokken</em> ontgrendeld! Voeg nog 1 artikel toe voor <em>[p]% korting op alles</em>.',
      Bsub: 'Met een derde artikel van ongeveer dezelfde prijs bespaar je <b>[x]</b>.',
      C: '<em>[p]% korting op alles</em> is actief.',
      Csub: 'Automatisch verrekend bij het afrekenen. Je gratis sokken gaan mee met je bestelling.',
      socks: 'Je gratis sokken', pick: 'Kies je kleur en maat',
      colors: { Zwart: 'Zwart', Wit: 'Wit' }
    },
    fr: {
      label: 'Votre avantage',
      t1: '1 article', s1: '-5 % avec code', t2: '2 articles', s2: 'Chaussettes offertes', t3: '3+ articles', s3: '-[p] %',
      A: 'Ajoutez 1 article et recevez des <em>chaussettes offertes</em> au choix.',
      Asub: 'Vous choisissez la couleur et la taille. Dès 3 articles, <b>-[p] % sur tout</b>.',
      B: '<em>Chaussettes offertes</em> débloquées ! Ajoutez 1 article pour <em>-[p] % sur tout</em>.',
      Bsub: 'Avec un 3e article au même prix, vous économisez <b>[x]</b>.',
      C: '<em>-[p] % sur tout</em> est activé.',
      Csub: 'Appliqué automatiquement au paiement. Vos chaussettes offertes partent avec votre commande.',
      socks: 'Vos chaussettes offertes', pick: 'Choisissez la couleur et la taille',
      colors: { Zwart: 'Noir', Wit: 'Blanc' }
    },
    de: {
      label: 'Dein Vorteil',
      t1: '1 Artikel', s1: '5 % mit Code', t2: '2 Artikel', s2: 'Gratis Socken', t3: '3+ Artikel', s3: '[p] % Rabatt',
      A: 'Füge noch 1 Artikel hinzu und erhalte <em>gratis Socken</em> nach Wahl.',
      Asub: 'Du wählst Farbe und Größe. Ab 3 Artikeln gibt es <b>[p] % Rabatt auf alles</b>.',
      B: '<em>Gratis Socken</em> freigeschaltet! Noch 1 Artikel für <em>[p] % Rabatt auf alles</em>.',
      Bsub: 'Mit einem dritten Artikel zum ähnlichen Preis sparst du <b>[x]</b>.',
      C: '<em>[p] % Rabatt auf alles</em> ist aktiv.',
      Csub: 'Wird an der Kasse automatisch abgezogen. Deine gratis Socken kommen mit deiner Bestellung.',
      socks: 'Deine gratis Socken', pick: 'Wähle Farbe und Größe',
      colors: { Zwart: 'Schwarz', Wit: 'Weiß' }
    },
    it: {
      label: 'Il tuo vantaggio',
      t1: '1 articolo', s1: '5% con codice', t2: '2 articoli', s2: 'Calze gratis', t3: '3+ articoli', s3: '[p]% di sconto',
      A: 'Aggiungi 1 articolo e ricevi <em>calze gratis</em> a tua scelta.',
      Asub: 'Scegli tu colore e taglia. Da 3 articoli hai <b>il [p]% di sconto su tutto</b>.',
      B: '<em>Calze gratis</em> sbloccate! Aggiungi 1 articolo per <em>il [p]% di sconto su tutto</em>.',
      Bsub: 'Con un terzo articolo allo stesso prezzo risparmi <b>[x]</b>.',
      C: '<em>[p]% di sconto su tutto</em> attivo.',
      Csub: 'Applicato automaticamente al checkout. Le tue calze gratis arrivano con il tuo ordine.',
      socks: 'Le tue calze gratis', pick: 'Scegli colore e taglia',
      colors: { Zwart: 'Nero', Wit: 'Bianco' }
    },
    en: {
      label: 'Your reward',
      t1: '1 item', s1: '5% with code', t2: '2 items', s2: 'Free socks', t3: '3+ items', s3: '[p]% off',
      A: 'Add 1 more item and get <em>free socks</em> of your choice.',
      Asub: 'You pick the colour and size. From 3 items you get <b>[p]% off everything</b>.',
      B: '<em>Free socks</em> unlocked! Add 1 more item for <em>[p]% off everything</em>.',
      Bsub: 'A third item at about the same price saves you <b>[x]</b>.',
      C: '<em>[p]% off everything</em> is active.',
      Csub: 'Applied automatically at checkout. Your free socks ship with your order.',
      socks: 'Your free socks', pick: 'Choose your colour and size',
      colors: { Zwart: 'Black', Wit: 'White' }
    }
  };
  var L = T[lang] || T.nl;

  var SOCK_COLORS = ['Zwart', 'Wit'];
  var SOCK_SIZES = ['34-38', '38-42', '42-46'];
  var SOCK_DOT = { Zwart: '#111827', Wit: '#ffffff' };
  var KEY_SOCKS = 'Cadeau sokken';
  var KEY_LACES = 'Cadeau veters';
  var SEP = ' · ';

  /* ---------- money ---------- */
  var cur = 'EUR';
  function money(cents) {
    var v = (Number(cents) || 0) / 100;
    var s;
    try {
      s = new Intl.NumberFormat(LOCALE, { style: 'currency', currency: cur }).format(v).replace(/ | /g, '');
    } catch (e) { s = '€' + v.toFixed(2).replace('.', ','); }
    return s;
  }
  function esc(t) {
    return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---------- cart helpers ---------- */
  function protVid() {
    try {
      var n = document.getElementById('CartDrawerProExtras');
      return n ? Number(JSON.parse(n.textContent).protectionVariantId) || 0 : 0;
    } catch (e) { return 0; }
  }
  var PROT = protVid();
  function isProt(i) { return !!PROT && Number(i.variant_id) === PROT; }

  function analyse(cart) {
    var items = (cart.items || []).filter(function (i) { return !isProt(i) && !(i.properties && i.properties._olyx_gift); });
    var count = 0, sub = 0, props = {};
    items.forEach(function (i) {
      count += i.quantity || 0;
      sub += Number(i.original_line_price != null ? i.original_line_price : i.line_price) || 0;
      var p = i.properties || {};
      if (p[KEY_SOCKS] && !props[KEY_SOCKS]) props[KEY_SOCKS] = p[KEY_SOCKS];
      if (p[KEY_LACES] && !props[KEY_LACES]) props[KEY_LACES] = p[KEY_LACES];
    });
    var code = (cart.discount_codes || []).some(function (d) { return d && d.applicable; });
    return { items: items, count: count, sub: sub, props: props, code: code, currency: cart.currency || 'EUR' };
  }

  /* ---------- markup ---------- */
  var ICON = {
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 21V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>',
    sock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 2h7v9l3.5 3.5a3.5 3.5 0 0 1-5 5L8 14z"/><path d="M8 6h7"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    star: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2.6l2.8 5.9 6.4.8-4.7 4.4 1.2 6.4L12 17l-5.7 3.1 1.2-6.4L2.8 9.3l6.4-.8z"/></svg>'
  };

  var el = document.createElement('section');
  el.className = 'AbcdLad';
  el.setAttribute('data-abcd-ladder', '');
  el.setAttribute('aria-label', L.label);
  el.hidden = true;
  el.innerHTML =
    '<div class="AbcdLad__head">' +
      '<span class="AbcdLad__ico">' + ICON.gift + '</span>' +
      '<div class="AbcdLad__copy">' +
        '<p class="AbcdLad__title" aria-live="polite"></p>' +
        '<p class="AbcdLad__sub"></p>' +
      '</div>' +
    '</div>' +
    '<div class="AbcdLad__tiers" role="list">' +
      '<span class="AbcdLad__tier" role="listitem" data-tier="1"><strong>' + esc(L.t1) + '</strong><em>' + esc(L.s1) + '</em></span>' +
      '<span class="AbcdLad__tier" role="listitem" data-tier="2"><strong>' + esc(L.t2) + '</strong><em>' + esc(L.s2) + '</em></span>' +
      '<span class="AbcdLad__tier AbcdLad__tier--best" role="listitem" data-tier="3"><strong>' + esc(L.t3) + '</strong><em>' + esc(L.s3.replace('[p]', pct3())) + '</em><i class="AbcdLad__star">' + ICON.star + '</i></span>' +
    '</div>' +
    '<div class="AbcdLad__socks" data-socks hidden></div>';

  var css = document.createElement('style');
  css.id = 'abcd-ladder-css';
  css.textContent = [
    '#CartDrawerPro.abcd-ladder-on .cdp-ms, #CartDrawerPro.abcd-ladder-on .cdp-shoe, #CartDrawerPro.abcd-ladder-on .OxUp--cart { display: none !important; }',
    '#CartDrawerPro .AbcdLad { position: relative; flex: 0 0 auto; margin: 0 16px 12px; padding: 14px 14px 12px; border: 2px solid transparent; border-radius: 18px; color: #17141f;',
    '  background: linear-gradient(#fff, #fff) padding-box, linear-gradient(120deg, #8b5cf6 0%, #6d5bd0 45%, #34c38f 100%) border-box;',
    '  box-shadow: 0 10px 26px rgba(76, 29, 149, .09); }',
    '#CartDrawerPro .AbcdLad[hidden] { display: none; }',
    '#CartDrawerPro .AbcdLad__head { display: flex; align-items: flex-start; gap: 10px; }',
    '#CartDrawerPro .AbcdLad__ico { flex: 0 0 auto; display: grid; place-items: center; width: 34px; height: 34px; border-radius: 11px; background: #f3efff; color: #7c3aed; }',
    '#CartDrawerPro .AbcdLad__ico svg { width: 19px; height: 19px; }',
    '#CartDrawerPro .AbcdLad__copy { flex: 1 1 auto; min-width: 0; }',
    '#CartDrawerPro .AbcdLad__title { margin: 1px 0 0; font-size: 15.5px; line-height: 1.3; font-weight: 800; letter-spacing: -.005em; color: #17141f; }',
    '#CartDrawerPro .AbcdLad__title em { font-style: normal; color: #15803d; }',
    '#CartDrawerPro .AbcdLad__sub { margin: 4px 0 0; font-size: 12.5px; line-height: 1.45; color: #5f5a6b; }',
    '#CartDrawerPro .AbcdLad__sub b { color: #15803d; font-weight: 800; }',
    '#CartDrawerPro .AbcdLad__sub:empty { display: none; }',
    '#CartDrawerPro .AbcdLad__tiers { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; margin: 12px 0 0; }',
    '#CartDrawerPro .AbcdLad__tier { position: relative; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px; min-height: 64px; padding: 9px 4px 10px; border: 1.5px solid #e7e3ef; border-radius: 14px; background: #fff; text-align: center; line-height: 1.15; transition: border-color .2s, box-shadow .2s, transform .2s; }',
    '#CartDrawerPro .AbcdLad__tier strong { font-size: 13px; font-weight: 800; color: #17141f; white-space: nowrap; }',
    '#CartDrawerPro .AbcdLad__tier em { font-style: normal; font-size: 11.5px; font-weight: 800; color: #6b6577; }',
    '#CartDrawerPro .AbcdLad__tier[data-tier="1"] em { padding: 3px 9px; border-radius: 999px; background: #f1eff6; color: #4b4557; }',
    '#CartDrawerPro .AbcdLad__tier[data-tier="2"] em { padding: 3px 9px; border-radius: 999px; background: #7c3aed; color: #fff; }',
    '#CartDrawerPro .AbcdLad__tier--best { border-color: #9be3b5; background: linear-gradient(180deg, #f3fcf6 0%, #e9f8ef 100%); }',
    '#CartDrawerPro .AbcdLad__tier--best em { padding: 3px 9px; border-radius: 999px; background: #16a34a; color: #fff; }',
    '#CartDrawerPro .AbcdLad__star { position: absolute; top: -10px; right: -8px; display: grid; place-items: center; width: 24px; height: 24px; border-radius: 50%; color: #fff;',
    '  background: radial-gradient(circle at 30% 25%, #ffe08a 0%, #f5b82e 55%, #e09a12 100%); box-shadow: 0 3px 8px rgba(224, 154, 18, .45), inset 0 0 0 1.5px rgba(255,255,255,.55); }',
    '#CartDrawerPro .AbcdLad__star svg { width: 13px; height: 13px; filter: drop-shadow(0 1px 0 rgba(150, 90, 0, .35)); }',
    '#CartDrawerPro .AbcdLad__tier.is-active { border: 2px solid #17141f; box-shadow: 0 4px 12px rgba(23, 20, 31, .08); }',
    '#CartDrawerPro .AbcdLad__tier.is-active strong::before { content: "\\2713\\00a0"; color: #16a34a; }',
    '#CartDrawerPro .AbcdLad__tier--best.is-active { border-color: #16a34a; box-shadow: 0 0 0 3px rgba(22, 163, 74, .16); }',
    '#CartDrawerPro .AbcdLad__tier.is-next { border: 2px dashed #8b5cf6; animation: abcdLadNext 1.9s ease-in-out infinite; }',
    '#CartDrawerPro .AbcdLad__tier--best.is-next { border-color: #22a35a; }',
    '@keyframes abcdLadNext { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.03); } }',
    '#CartDrawerPro .AbcdLad__socks { margin: 12px 0 0; padding: 11px 0 0; border-top: 1px solid #efecf4; }',
    '#CartDrawerPro .AbcdLad__socks[hidden] { display: none; }',
    '#CartDrawerPro .AbcdSock__top { display: flex; align-items: center; gap: 8px; margin: 0 0 9px; }',
    '#CartDrawerPro .AbcdSock__top svg { flex: 0 0 auto; width: 17px; height: 17px; color: #e09a12; }',
    '#CartDrawerPro .AbcdSock__top strong { font-size: 13px; font-weight: 800; color: #17141f; }',
    '#CartDrawerPro .AbcdSock__top span { margin-left: auto; font-size: 11.5px; font-weight: 600; color: #7a7486; }',
    '#CartDrawerPro .AbcdSock__chips { display: flex; flex-wrap: wrap; gap: 6px; }',
    '#CartDrawerPro .AbcdSock__chips + .AbcdSock__chips { margin-top: 7px; }',
    '#CartDrawerPro .AbcdSock__chip { display: inline-flex; align-items: center; gap: 7px; min-height: 34px; padding: 0 13px; border: 1.5px solid #e2ddea; border-radius: 999px; background: #fff; color: #2b2633; font: 700 12.5px/1 inherit; font-family: inherit; cursor: pointer; transition: border-color .15s, background .15s, color .15s; }',
    '#CartDrawerPro .AbcdSock__chip:hover { border-color: #b9a8f0; }',
    '#CartDrawerPro .AbcdSock__chip.is-on { border-color: #7c3aed; background: #f5f2ff; color: #4c1d95; box-shadow: 0 0 0 3px rgba(124, 58, 237, .12); }',
    '#CartDrawerPro .AbcdSock__chip[disabled] { opacity: .6; cursor: default; }',
    '#CartDrawerPro .AbcdSock__dot { width: 13px; height: 13px; border-radius: 50%; border: 1.5px solid #cfc8db; }',
    '@media (max-height: 760px) { #CartDrawerPro .AbcdLad__sub { display: none; } }',
    '@media (max-height: 880px) { #CartDrawerPro.abcd-ladder-on .cdp-trust { display: none; } }',
    '@media (max-width: 400px) { #CartDrawerPro .AbcdLad { margin: 0 12px 10px; padding: 12px 11px 11px; } #CartDrawerPro .AbcdLad__title { font-size: 14.5px; } #CartDrawerPro .AbcdLad__tier strong { font-size: 12px; } #CartDrawerPro .AbcdLad__tier em { font-size: 10.5px; padding: 3px 7px; } #CartDrawerPro .AbcdLad__ico { width: 30px; height: 30px; } }',
    '@media (prefers-reduced-motion: reduce) { #CartDrawerPro .AbcdLad__tier { animation: none !important; transition: none !important; } }'
  ].join('\n');
  (document.head || document.documentElement).appendChild(css);

  var tTitle = el.querySelector('.AbcdLad__title');
  var tSub = el.querySelector('.AbcdLad__sub');
  var socksBox = el.querySelector('[data-socks]');
  anchor.parentNode.insertBefore(el, anchor);
  root.classList.add('abcd-ladder-on');

  /* ---------- cart writes ---------- */
  var busy = false, fails = 0;
  function post(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }
  function refreshDrawer() { document.dispatchEvent(new CustomEvent('cart:refresh')); }

  /* write gift properties on the first line in ONE request.
     map: { 'Cadeau sokken': 'Zwart · 38-42' }; a value of '' removes that property. */
  function writeProps(map) {
    if (busy) return Promise.resolve();
    var keys = Object.keys(map);
    if (!keys.length) return Promise.resolve();
    busy = true;
    var removing = keys.every(function (k) { return map[k] === ''; });
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var idx = -1, i;
        for (i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          if (isProt(it) || it.requires_shipping === false) continue;
          if (removing) {
            if (keys.some(function (k) { return it.properties && it.properties[k]; })) { idx = i; break; }
          } else { idx = i; break; }
        }
        if (idx < 0) return null;
        var line = cart.items[idx];
        var props = {};
        var existing = line.properties || {};
        Object.keys(existing).forEach(function (k) { props[k] = existing[k]; });
        keys.forEach(function (k) { if (map[k] === '') delete props[k]; else props[k] = map[k]; });
        /* always send the current quantity: change.js with only properties resets the line to 1 */
        return post('/cart/change.js', { id: line.key, quantity: line.quantity, properties: props });
      })
      .then(function (res) { busy = false; if (res !== null) refreshDrawer(); }, function () { busy = false; fails++; });
  }
  function one(k, v) { var o = {}; o[k] = v; return o; }

  /* ---------- socks: chosen for the shopper, changeable with one tap ---------- */
  function parseSock(v) {
    var p = String(v || '').split(SEP);
    return { color: p[0] || 'Zwart', size: p[1] || '38-42' };
  }
  /* sock size from the first shoe size in the cart (EU number), 38-42 when unknown */
  function defaultSize(items) {
    for (var i = 0; i < items.length; i++) {
      var m = /EU\s*([\d.]+)/i.exec(items[i].variant_title || '');
      if (m) { var n = parseFloat(m[1]); return n < 38 ? '34-38' : (n <= 42 ? '38-42' : '42-46'); }
    }
    return '38-42';
  }
  function colorName(c) { return (L.colors && L.colors[c]) || c; }
  function chip(label, on, attrs, dot) {
    return '<button type="button" class="AbcdSock__chip' + (on ? ' is-on' : '') + '" aria-pressed="' + (on ? 'true' : 'false') + '" ' + attrs + '>' +
      (dot ? '<span class="AbcdSock__dot" style="background:' + dot + '"></span>' : '') + esc(label) + '</button>';
  }
  function renderSocks(a) {
    var sv = a.count >= 2 ? a.props[KEY_SOCKS] : '';
    var html = '';
    if (sv) {
      var cs = parseSock(sv);
      html = '<div class="AbcdSock__top">' + ICON.sock + '<strong>' + esc(L.socks) + '</strong><span>' + esc(L.pick) + '</span></div>' +
        '<div class="AbcdSock__chips" role="group" aria-label="' + esc(L.socks) + '">' + SOCK_COLORS.map(function (c) { return chip(colorName(c), cs.color === c, 'data-sc="' + c + '"', SOCK_DOT[c]); }).join('') + '</div>' +
        '<div class="AbcdSock__chips" role="group" aria-label="' + esc(L.socks) + '">' + SOCK_SIZES.map(function (s) { return chip(s, cs.size === s, 'data-ss="' + s + '"'); }).join('') + '</div>';
    }
    if (socksBox.getAttribute('data-sig') !== html) {
      socksBox.innerHTML = html;
      socksBox.setAttribute('data-sig', html);
    }
    socksBox.hidden = !html;
  }
  socksBox.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button');
    if (!b || !last) return;
    var v, cs = parseSock(last.props[KEY_SOCKS]);
    if ((v = b.getAttribute('data-sc'))) { if (v !== cs.color) writeProps(one(KEY_SOCKS, v + SEP + cs.size)); return; }
    if ((v = b.getAttribute('data-ss'))) { if (v !== cs.size) writeProps(one(KEY_SOCKS, cs.color + SEP + v)); }
  });

  /* ---------- paint ---------- */
  var last = null;
  var lastTry = { sig: '', t: 0 };

  function paint(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    var a = analyse(cart);
    last = a;
    cur = a.currency || 'EUR';
    if (a.count === 0) { el.hidden = true; socksBox.hidden = true; socksBox.innerHTML = ''; socksBox.removeAttribute('data-sig'); return; }
    el.hidden = false;

    var p = pct3();
    var title, sub;
    if (a.count >= 3) { title = L.C; sub = L.Csub; }
    else if (a.count === 2) {
      title = L.B;
      var avg = Math.round(a.sub / 2);
      var save = Math.round((a.sub + avg) * p / 100);
      sub = save >= 100 ? L.Bsub.replace('[x]', money(save)) : '';
    } else { title = L.A; sub = L.Asub; }
    title = title.replace(/\[p\]/g, p);
    sub = sub.replace(/\[p\]/g, p);
    if (tTitle.innerHTML !== title) tTitle.innerHTML = title;
    if (tSub.innerHTML !== sub) tSub.innerHTML = sub;

    var active = a.count >= 3 ? 3 : a.count;
    var next = a.count >= 3 ? 0 : a.count + 1;
    for (var n = 1; n <= 3; n++) {
      var te = el.querySelector('[data-tier="' + n + '"]');
      /* step 1 only counts as reached when a code is on the cart (the welcome code) */
      var on = n === active && (n !== 1 || a.code);
      te.classList.toggle('is-active', on);
      te.classList.toggle('is-next', n === next);
    }
    el.setAttribute('data-state', String(Math.min(a.count, 3)));
    renderSocks(a);

    /* socks follow the step: added from 2 items, removed below 2; old free laces are always removed */
    var todo = {};
    if (a.props[KEY_LACES]) todo[KEY_LACES] = '';
    if (a.count < 2 && a.props[KEY_SOCKS]) todo[KEY_SOCKS] = '';
    if (!Object.keys(todo).length && a.count >= 2 && !a.props[KEY_SOCKS]) todo[KEY_SOCKS] = 'Zwart' + SEP + defaultSize(a.items);
    var tsig = JSON.stringify(todo);
    if (!busy && fails < 3 && Object.keys(todo).length && !(lastTry.sig === tsig && Date.now() - lastTry.t < 6000)) {
      lastTry = { sig: tsig, t: Date.now() };
      writeProps(todo);
    }
  }

  document.addEventListener('cdp:updated', function (e) {
    if (e && e.detail && e.detail.cart) paint(e.detail.cart);
  });

  /* safety net: if the drawer events do not fire, follow the cart requests */
  var refreshing = null;
  function pull() {
    if (refreshing) return;
    refreshing = setTimeout(function () {
      refreshing = null;
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(paint, function () {});
    }, 150);
  }
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function () {
      var u = arguments[0];
      var href = typeof u === 'string' ? u : (u && u.url) || '';
      var pr = origFetch.apply(this, arguments);
      if ((href.indexOf('/cart/') !== -1 && href.indexOf('/cart.js') === -1) || href.indexOf('/discount/') !== -1) { pr.then(pull, function () {}); }
      return pr;
    };
  }

  /* soft failure: if the card never appears while the drawer has items, bring the old bar back */
  setTimeout(function () {
    if (el.hidden && root.querySelector('.cdp__item')) root.classList.remove('abcd-ladder-on');
  }, 4000);
  var boot = document.getElementById('CartDrawerProCart');
  if (boot) { try { paint(JSON.parse(boot.textContent)); } catch (e) { pull(); } } else { pull(); }
})();
